<cmps-dialog class="h-100 cmps-cdk-pr-0dot75 cmps-cdk-ml-0dot25">
    <!-- intentionally not using background-image -->
    <div class="cmps-event-centre-dialog--icaw">
        <img
            src="assets/intelligent-coach-assist-watermark.svg"
            alt=""
            aria-hidden="true"
        />
    </div>
    <cmps-dialog-header>
        <div class="cmps-event-centre-dialog--header">
            <div>
                <img
                    class="cmps-event-centre-dialog--icai"
                    src="assets/intelligent-coach-assist-icon.svg"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <cmps-event-centre-tab-bar
                class="flex-grow-1"
                [class.cmps-cdk-d-none]="_service.state?.searchOpen"
            ></cmps-event-centre-tab-bar>
            <div
                class="cmps-cdk-d-flex cmps-cdk-align-items-center"
                [class.cmps-cdk-d-none]="_service.state?.searchOpen"
            >
                <div
                    class="cmps-cdk-mr-0dot5"
                    *ngFor="let a of _service.state?.category?.actions"
                >
                    <button
                        class="cmps-icon-button--no-bg"
                        [class.cmps-cdk-d-none]="a.styleHidden === true"
                        cmpsIconButton
                        [disabled]="a.styleDisabled === true"
                        [cmpsTooltipTrigger]="a.name"
                        (click)="_onCategoryActionClick(a)"
                        *ngIf="
                            a.displayAs?.toLowerCase() ===
                                _CategoryDisplayAs.Icon?.toLowerCase() ||
                            a.displayAs == null
                        "
                    >
                        <cmps-icon [svgIcon]="a.icon"></cmps-icon>
                    </button>
                    <button
                        class="cmps-cdk-min-w-auto cmps-cdk-min-h-34p cmps-cdk-border-color-blue-100 cmps-cdk-color-blue-100 not:disabled:hover:cmps-cdk-bg-color-blue-100 not:disabled:focus:cmps-cdk-bg-color-blue-100 not:disabled:hover:cmps-cdk-color-white not:disabled:focus:cmps-cdk-color-white not:disabled:hover:cmps-cdk-pseudo-child not:disabled:focus:cmps-cdk-pseudo-child"
                        [class.cmps-cdk-d-none]="a.styleHidden === true"
                        cmpsOutlineButton
                        [disabled]="a.styleDisabled === true"
                        (click)="_onCategoryActionClick(a)"
                        *ngIf="
                            a.displayAs?.toLowerCase() ===
                            _CategoryDisplayAs?.IconAndName?.toLowerCase()
                        "
                    >
                        <cmps-icon
                            class="cmps-cdk-fill-blue-100 not:disabled:hover:cmps-cdk-fill-white not:disabled:focus:cmps-cdk-fill-white"
                            [svgIcon]="a.icon"
                        ></cmps-icon>
                        <span cmpsOutlineButtonLabel>{{ a.name }}</span>
                    </button>
                </div>
            </div>
            <cmps-event-centre-search-filter></cmps-event-centre-search-filter>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                    (click)="_service.close()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body
        class="cmps-event-centre-dialog--body cmps-cdk-pr-0dot5 cmps-cdk-pos-relative"
    >
        <cmps-uikit-virtual-scroll
            [templateRef]="viewTpl"
            [offset]="12"
            [itemHeight]="92"
            [items]="_service.state?.filteredItems"
        ></cmps-uikit-virtual-scroll>
    </cmps-dialog-body>
</cmps-dialog>

<ng-template
    let-items="items"
    #viewTpl
>
    <cmps-event-centre-card-collection
        [items]="items"
    ></cmps-event-centre-card-collection>
</ng-template>
